const boxIconMap = {
  edit_icon: 'edit_icon',
}
export default boxIconMap
